export const REFRESH_QUERY_PARAM = { grant_type: 'refresh_token' }
export const PASSWORD_QUERY_PARAM = { grant_type: 'password' }
export const DETAILED_QUERY_PARAM = { projection: 'detailed' }
export const LIST_QUERY_PARAM = { projection: 'list' }
export const SIMPLE_QUERY_PARAM = { projection: 'simple' }
